"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelHiddenImageVisibility = exports.CollectionModelHiddenImageVisibilityMutator = void 0;
var tslib_1 = require("tslib");
var imageVisibility_1 = require("./imageVisibility");
var CollectionModelHiddenImageVisibilityMutator = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelHiddenImageVisibilityMutator, _super);
    function CollectionModelHiddenImageVisibilityMutator(imageVisibility) {
        return _super.call(this, imageVisibility) || this;
    }
    CollectionModelHiddenImageVisibilityMutator.prototype.init = function (hidden) {
        this.imageVisibility.imageVisibilityState.Mutator.create('hidden');
        this.setHidden(hidden);
    };
    CollectionModelHiddenImageVisibilityMutator.prototype.setHidden = function (hidden) {
        var state = this.getValue();
        state.hidden = hidden;
        this.setValue(state);
    };
    return CollectionModelHiddenImageVisibilityMutator;
}(imageVisibility_1.CollectionModelImageVisibilityMutator));
exports.CollectionModelHiddenImageVisibilityMutator = CollectionModelHiddenImageVisibilityMutator;
var CollectionModelHiddenImageVisibility = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelHiddenImageVisibility, _super);
    function CollectionModelHiddenImageVisibility() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this.tag = CollectionModelHiddenImageVisibility.TAG;
        _this.Mutator = new CollectionModelHiddenImageVisibilityMutator(_this);
        return _this;
    }
    CollectionModelHiddenImageVisibility.state = function (id) {
        return {
            id: id,
            tag: 'hidden',
            hidden: false
        };
    };
    CollectionModelHiddenImageVisibility.isHidden = function (t) {
        return (t === null || t === void 0 ? void 0 : t.tag) === CollectionModelHiddenImageVisibility.TAG;
    };
    Object.defineProperty(CollectionModelHiddenImageVisibility.prototype, "hidden", {
        get: function () {
            var state = this.state;
            if (!state) {
                return false;
            }
            return state.hidden;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelHiddenImageVisibility.TAG = 'hidden';
    return CollectionModelHiddenImageVisibility;
}(imageVisibility_1.CollectionModelImageVisibility));
exports.CollectionModelHiddenImageVisibility = CollectionModelHiddenImageVisibility;
//# sourceMappingURL=hidden.imageVisibility.js.map